import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';
@Pipe({ name: 'src' })
export class SrcPipe implements PipeTransform {
  transform(url: string) {
    if(!url){
      return "";
    }
    if (url.indexOf('base64') != -1||url.indexOf('http')!= -1 ) {
      return url;
    }
    if(environment.aliyunOSS.use){
      var host='https://' + environment.aliyunOSS.bucket + '.' + environment.aliyunOSS.region + '.aliyuncs.com' ;
      return host+url;
    }
    return this.removeSpace(environment.SERVER_URL) + url;
  }
  removeSpace(str) {
    return str.substring(0, str.length-1);
  };
}
